export const API_URL = import.meta.env.VITE_API_URL || '/api';

export class ApiError extends Error {
  status: number;
  data?: unknown;

  constructor(message: string, status?: number, data?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status || 500;
    this.data = data;
  }
}

export async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const data = await response.json().catch(() => null);

    if (response.status === 409) {
      throw new ApiError('Email already registered', response.status, data);
    }

    const message =
      data?.error || `Request failed with status ${response.status}`;
    throw new ApiError(message, response.status, data);
  }

  return response.json();
}
